<template>
  <v-dialog
    v-model="dialog"
    :max-width="width"
    :style="{ zIndex: 200 }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          {{ $t("message.common.confirm") }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-5">
        <template v-if="$slots.default">
          <slot />
        </template>
        <template v-else>
          {{ display_message }}
        </template>
      </v-card-text>
      <v-card flat class="pb-1 pr-3">
        <p class="text-right">
          <template v-if="positive">
            <v-btn color="primary" @click.native="agree">
              {{ positive }}
            </v-btn>
          </template>
          <v-btn @click.native="cancel" ref="cancel">
            {{ negative }}
          </v-btn>
        </p>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirm',
  data: () => ({
    module_id: "67",

    dialog: false,
    display_message: "",
    width: 300,
    resolve: null,
    reject: null,
  }),
  props: {
    message: String,
    positive: String,
    negative: String
  },
  methods: {
    open(message=null, width=null) {
      if(message !== null){
        this.display_message = message;
      }else{
        this.display_message = this.message;
      }
      if(width !== null){
        this.width = width;
      }
      this.dialog = true;
      setTimeout(() => {
        this.$refs.cancel.$el.focus();
      });
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
      this.remove_range()
    },
    remove_range(){
      const selection = window.getSelection();
      if(selection.toString()){
        const range = selection.getRangeAt(0);
        selection.removeAllRanges(range);
      }
    }
  }
}
</script>
